import Cache from 'root/cache';
import Collection_Base from 'collection/base';
import Model_Project from 'model/project';

export default Collection_Base.extend({
    model: Model_Project,

    sort_by: 'updated', // updated, created, name
    sort_order: 'desc', // desc, asc
    group_by: '', // domain

    initialize: function() {
        this.sort_by    = Cache.app.getUserSetting('project_sort_by')    || 'updated';
        this.sort_order = Cache.app.getUserSetting('project_sort_order') || 'desc';
        this.group_by   = Cache.app.getUserSetting('project_group_by')   || '';

        if (['updated', 'created', 'name'].indexOf(this.sort_by) === -1) {
            this.sort_by = 'updated';
        }

        if (['desc', 'asc'].indexOf(this.sort_order) === -1) {
            this.sort_order = 'desc';
        }
    },

    resetSortCache: function() {
        Cache.project.starred_project_ids = null;
    },

    getStarredProjectIds: function() {
        // Cache starred project ids because it is used in the comparator
        if (!this.starred_project_ids) {
            this.starred_project_ids = Cache.app.getUserSetting('project_starred');

            if (!this.starred_project_ids) {
                this.starred_project_ids = [];
            } else {
                this.starred_project_ids = this.starred_project_ids.split(',').map(Number);
            }
        }

        return this.starred_project_ids;
    },

    comparator: function(a, b) {
        var is_a_starred = this.getStarredProjectIds().indexOf(a.id) !== -1;
        var is_b_starred = this.getStarredProjectIds().indexOf(b.id) !== -1;

        if (is_a_starred && !is_b_starred) {
            return -1;
        } else if (is_b_starred && !is_a_starred) {
            return 1;
        }

        if (Cache.statistics && Cache.statistics.get('project_count')) {
            switch (this.sort_by) {
                case 'updated':
                    var updated_time_a = Cache.statistics.get('project_count')[a.id] ? Cache.statistics.get('project_count')[a.id].updated : 0;
                    var updated_time_b = Cache.statistics.get('project_count')[b.id] ? Cache.statistics.get('project_count')[b.id].updated : 0;

                    if (updated_time_a > updated_time_b) {
                        return this.sort_order === 'desc' ? -1 : 1;
                    } else if (updated_time_a < updated_time_b) {
                        return this.sort_order === 'desc' ? 1 : -1;
                    } else {
                        return 0;
                    }

                    break;
                case 'created':
                    if (a.get('create_time') > b.get('create_time')) {
                        return this.sort_order === 'desc' ? -1 : 1;
                    } else if (a.get('create_time') < b.get('create_time')) {
                        return this.sort_order === 'desc' ? 1 : -1;
                    } else {
                        return 0;
                    }

                    break;
                case 'name':
                    if (a.get('name').toLowerCase() > b.get('name').toLowerCase()) {
                        return this.sort_order === 'desc' ? -1 : 1;
                    } else if (a.get('name').toLowerCase() < b.get('name').toLowerCase()) {
                        return this.sort_order === 'desc' ? 1 : -1;
                    } else {
                        return 0;
                    }

                    break;
            }
        } else {
            return a.get('create_time') >= b.get('create_time') ? -1 : 1;
        }
    }
});